export const Error404: React.FC = () => <h1>404 - Not Found</h1>
